module.exports = __webpack_public_path__ + "img/5.5edb9480.webp";